import MuiTooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import cx from 'classnames';
import Tooltip from 'components/common/tooltip';
import {formatReferenceCopy as formatDemoCopy} from 'utils/typography';
import {COLORS} from 'config/constants';

import './property.scss';

const rowTextStyles = {
  lineHeight: '21px',
  marginBlock: 'calc(-1em / 28)',
  letterSpacing: 0,
};

const CustomsProperty = ({label, value, secondary, nested, informer, showInformer}: CustomsPropertyProps) => {
  const labelColor = secondary ? COLORS.LIGHT_TEXT_DISABLED : COLORS.LIGHT_TEXT_SECONDARY;
  const valueColor = secondary ? COLORS.LIGHT_TEXT_DISABLED : COLORS.BLACK_DARK;

  const formatContent = (content: React.ReactNode) => typeof content === 'string' ? formatDemoCopy(content) : content;

  return (
    <div className={cx('customs-property', {
      'customs-property_secondary': secondary,
      'customs-property_nested': nested,
    })}>
      <div className='customs-property__label'>
        {showInformer && <Tooltip content={informer} sx={{
          width: 20,
          height: 20,
        }} />}
        <MuiTooltip title={showInformer ? '' : informer || ''}>
          <Typography
            component='span'
            tabIndex={informer ? 0 : undefined}
            variant='body2'
            sx={{
              color: labelColor,
              ...rowTextStyles,
            }}
          >
            {formatContent(label)}
          </Typography>
        </MuiTooltip>
      </div>
      <Typography
        component='div'
        variant='body2'
        className='customs-property__value'
        sx={{
          color: valueColor,
          ...rowTextStyles,
        }}
      >
        {formatContent(value)}
      </Typography>
    </div>
  );
};

export default CustomsProperty;
